import * as React from 'react';
import { CircularProgress } from '@material-ui/core';

export const Loading = () => <CircularProgress />;